import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer
}

export const selectRouterState = createFeatureSelector<
  RouterReducerState
>('router')

export interface AppState {
  router?: RouterReducerState
}
